/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TypePrivateNumberAccesses {
  Bulk = 0,
  InteractiveBulk = 1,
  SmsMT = 2,
  SmsMO = 3,
  USSDMT = 4,
  USSDMO = 5,
  OPT = 6
}
